import React, { useState, useEffect } from 'react'
import { useOktaAuth } from '@okta/okta-react'
import { Card, Col, Form, Button } from '@deere/ux.uxframe-react'
import { getActiveSurveys } from '../../services/campaign.service';
import { validateSupplierNumbersByChunk } from '../../services/external.service';
import CustomAlert from '../../components/CustomAlert'
import { CRS_REQUEST_STATUS_OBJ, SCBM_STATES_CAMPAIGN, DEFAULT_NOT_CONFIG, CRS_SURVEY_CODES, NOTIFIC_TEMPLATE_CODE_INITIAL, NOTIFIC_TEMPLATE_CODE_REMINDER, EXT_REQUEST_CONTEXT, CRS_SURVEY_TEMPLATES, QUESTION_TYPES, OPEN_CAMPAIGN_END_DATE, LBL_SURVEYID, LBL_ISNONDEERE, LBL_ISOPENCAMPAIGN, LBL_COMPANYNAME, LBL_FETCHHISTORY, LBL_ISOPENCAMPAIGN_RADIO, ENV_PROD, SURVEYPART_SECTION_TYPES, FETCH_SURVEY_DATA } from '../../utils/surveyLiterals'
import { getUserInfo } from '../../services/userService';
import { Spinner } from '@deere/ux.uxframe-react';
import { useHistory } from 'react-router'
import RemainderSettings from '../../components/admin/RemainderSettings';
import { COC_SHOW_INTEGRATION_SECTION, CURRENT_ENV, URL_APP } from "../../utils/constEnvVariables";
import { postCMSurvey, postEMSurvey, postCampaign } from '../../utils/saveSurveyUtils';
import SurveyFactory from '../admin/SurveyComponentFactory';
import { getTemplateBySurveyCode, getSurveyHistoryBySurveyCode, getSurveyById } from "../../services/survey.service";
import IntegrationSettings from '../../components/admin/IntegrationSettings';
import { Stack } from '@mui/material';
import { DEFAULT_COMPANY } from "../../utils/surveyLiterals"
import AttachmentUploads from '../../components/admin/AttachmentUploads';
import { ERR_ATTACHMENT, ERR_CC_FIELD, ERR_CMRT_FILE, ERR_EMAIL_TEMPLATE, ERR_END_DATE, ERR_FROM_FIELD, ERR_TO_FIELD } from '../../utils/errorLiterals';
import { Grid, Typography } from '@deere/fuel-react';

export default function Campaign() {
    const { authState } = useOktaAuth();
    const [surveys, setSurveys] = useState(undefined);
    const [validated, setValidated] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [userInfo, setuserInfo] = useState(undefined);
    const [loading, setLoading] = useState(false);
    const [disableSubmit, setDisableSubmit] = useState(true);
    const [isConflictMineral, setIsConflictMineral] = useState(false);
    const [initNotificationSubj, setInitNotificationSubj] = useState('');
    const [remNotificationSubj, setRemNotificationSubj] = useState('');
    const [inputFile, setInputFile] = useState('');
    const [from,setFrom] = useState('')
    const [to,setTo] = useState('')
    const [cc,setCc] = useState([])
    const [backupContact,setBackupContact] = useState('0')
    const history = useHistory();
    const [surveySelectedCd,setSurveySelectedCd] = useState([])
    const [notificationTemplate, setNotificationTemplate] = useState([]);
    const [selectedQues, setSelectedQues] = useState([]);
    const [selectedSec, setSelectedSec] = useState([]);
    const [nonDeereAvailable, setNonDeereAvailable] = useState(false);
    const [lblCompanyName, setLblCompanyName] = useState(DEFAULT_COMPANY);
    const [campaign, setCampaign] = useState({
        surveyId: undefined,
        active: true,
        startDate: undefined,
        endDate: undefined,
        assignments: [],
        supplierNumbers: undefined,
        code: undefined,
        status: SCBM_STATES_CAMPAIGN.OPEN,
        notificationConfig: DEFAULT_NOT_CONFIG,
        isNonDeere: false,
        companyName: "",
        templateType: "",
        fetchHistoricalData: false,
        isOpenEndedCampaign: false,
    });
    const [isEnable, setIsEnable] =useState(false);
    const [viewerQuestions, setViewerQuestions] = useState([]);
    const [attachmentFiles, setAttachmentFiles] = useState([]);
    const [partSections, setPartSections] = useState([]);
    const [partTemplateColumns, setPartTemplateColumns] = useState({deere: [], nonDeere: []});
    const [factoryLoader, setFactoryLoader] = useState(false);
    
    useEffect(() => {
        try {
            getUserInfo(authState.accessToken.accessToken)
                .then((u) => {
                    setuserInfo(u);
                    try {
                        getActiveSurveys(authState.accessToken.accessToken)
                            .then((surveys) => {
                                const surveysByUser = surveys? surveys.filter(s => u.roles.includes(s.adminRole)) : null;
                                setSurveys(surveysByUser);
                            })
                    } catch (error) {
                        console.log(error);
                    }
                })
        } catch (error) {
            console.log(error);
        }
    }, [authState.accessToken.accessToken]);

    useEffect(() => {
        if (campaign && campaign.surveyId && campaign.surveyId!=="") {
          let survey = surveys.find((s) => s.id == campaign.surveyId);
          let surveyCode = survey ? survey.code : "";
          if (surveyCode !== "") {
            getTemplateBySurveyCode(surveyCode, authState.accessToken.accessToken)
              .then((res) => {
                if(res && Array.isArray(res) && res.length > 0){
                    setNotificationTemplate(res);
                }
              })
              .catch((err) => console.log(err));
          }
        }
      }, [campaign.surveyId, authState.accessToken.accessToken]);

    useEffect(()=>{
        if (campaign && campaign.surveyId && campaign.surveyId!=="") {
            let survey = surveys.find((s) => s.id == campaign.surveyId);
            let surveyCode = survey ? survey.code : "";
            if (surveyCode !== "") {
                const payload ={
                  surveyCode: surveyCode,
                  isNonDeere: campaign.isNonDeere
                }
                getSurveyHistoryBySurveyCode(payload, authState.accessToken.accessToken)
                .then((res) => {
                  if(res==="" ||res.length===0){
                      setIsEnable(false);
                  }else{
                      setIsEnable(true);
                  }
                })
                .catch((err) => console.log(err));
            }
          }
      },[campaign.surveyId, campaign.isNonDeere, authState.accessToken.accessToken])

    useEffect(() => {
        if(campaign && campaign.surveyId && campaign.surveyId !== "") {
            let survey = surveys.find((s) => s.id.toString() === campaign.surveyId);
            if(survey && survey.nonDeereUse){
                setNonDeereAvailable(true);
            }
            else{
                setNonDeereAvailable(false);
                setCampaign((prevState) => {
                    return {...prevState, isNonDeere: false, companyName: ""}
                })
                setLblCompanyName(DEFAULT_COMPANY);
            }
        }
    }, [campaign.surveyId]);

    useEffect(() => {
        if (campaign.surveyId) {
          setFactoryLoader(true);
          getSurveyById(campaign.surveyId, authState.accessToken.accessToken)
            .then((survey) => {
              if (survey) {
                let tempArr = [];
                let tempArrPart = []
                survey.sections.forEach((section) => {
                  const viewerQuestions = section.questions.filter((question) => question.type === QUESTION_TYPES.VIEWER);
                  if (viewerQuestions.length > 0) tempArr = tempArr.concat(viewerQuestions);
                  if (section.type === SURVEYPART_SECTION_TYPES.PART) tempArrPart.push(section.description);
                });
                setPartSections(tempArrPart);
                if (tempArr.length > 0) setViewerQuestions(tempArr);
                else {
                    setViewerQuestions([]);
                    setAttachmentFiles([]);
                }
                let tempObjD = {};
                let tempObjND = {};
                survey.defaultColumns.forEach((col) => {
                    col.isNonDeere ? tempObjND[col.columnNames] = "" : tempObjD[col.columnNames] = "";
                });
                if (tempArrPart.length > 1) {
                    tempObjD.Section = "";
                    tempObjND.Section = "";
                }
                setPartTemplateColumns({deere: [tempObjD], nonDeere: [tempObjND]});
              }
              setFactoryLoader(false);
            })
            .catch((err) => {
                console.log(err);
                setFactoryLoader(false);
            });
        }
      }, [campaign.surveyId]);
      
    // get min date for start date selection
    const pastDate=()=>{
        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(today.getDate() + 1);
        return tomorrow.toISOString().split('T')[0];
    }

    const minimumDate = pastDate();
    const onChange = event => {
        let tmpCampaign = { ...campaign };
        tmpCampaign[event.target.name] = event.target.value;
        switch (event.target.name) {
            case LBL_SURVEYID:
                let surveySelected = surveys.find((s) => s.id === Number(event.target.value));
                if(surveySelected && surveySelected.code){
                    tmpCampaign.code = surveySelected.code;
                    tmpCampaign.templateType = surveySelected.templateType;
                }
                break;
            case LBL_ISNONDEERE:
                tmpCampaign.isNonDeere = event.target.value === "true" ? true : false;
                if(event.target.value !== "true"){
                    tmpCampaign.companyName = "";
                    setLblCompanyName(DEFAULT_COMPANY);
                }
                break;
            case LBL_ISOPENCAMPAIGN:
                if (event.target.value === "true") {
                    tmpCampaign.isOpenEndedCampaign = true;
                    tmpCampaign.endDate = OPEN_CAMPAIGN_END_DATE;
                    setDisableSubmit(false);
                    tmpCampaign.assignments = [];
                } else {
                    tmpCampaign.isOpenEndedCampaign = false;
                    tmpCampaign.endDate = "";
                    setDisableSubmit(true);
                }
                break;
            case LBL_COMPANYNAME:
                setLblCompanyName(event.target.value);
                break;
            case LBL_FETCHHISTORY:
                event.target.value === "true" ? tmpCampaign.fetchHistoricalData = true : tmpCampaign.fetchHistoricalData = false;
                break;
        }
        setCampaign({ ...tmpCampaign });
        findSurveyName(event.target.value);
        if (event.target.name === 'supplierNumbers') {
            if (!disableSubmit)
                setDisableSubmit(true);
            if (!successMessage);
            setSuccessMessage('');
            if (!validated);
            setValidated(false);
        } else {
            setValidated(false);
        }
    }

    const findSurveyName = (surveyId) => {
        try {
            if (surveyId && surveys) {
                for (let i = 0; i < surveys.length; i++) {
                    if (isInteger(surveyId)) {
                        const idInt = parseInt(surveyId)
                        if (idInt === surveys[i].id) {
                            setSurveySelectedCd(surveys[i].code);
                            (CRS_SURVEY_CODES.CM === surveys[i].code) ? setIsConflictMineral(true) : setIsConflictMineral(false);
                            setInitNotificationSubj(surveys[i].description);
                            setRemNotificationSubj(surveys[i].description);
                        }
                    }
                }
            }
        }
        catch (exception) {
            console.log(exception);
            setInitNotificationSubj('');
            setRemNotificationSubj('');
        }
    }

    function isInteger(n) {
        return /^[+-]?\d+$/.test(n);
    }


    const handleSubmit = event => {
        setLoading(true);
        setSuccessMessage('');
        setErrorMessage('');
        let form = event.currentTarget;
        let tmpCampaign = { ...campaign };
        surveys.forEach(sur => {
            if (sur.id === Number(tmpCampaign.surveyId)) {
                tmpCampaign.code = sur.code;
                tmpCampaign.notificationConfig.remNotificationSubj = `REMINDER - ${lblCompanyName} ${sur.description} Request - ACTION REQUIRED`;
                tmpCampaign.notificationConfig.initNotificationSubj = `${lblCompanyName} ${sur.description} Request - ACTION REQUIRED`;
                tmpCampaign.notificationConfig.urlRequestNumber = tmpCampaign.isNonDeere ?  URL_APP + EXT_REQUEST_CONTEXT : URL_APP + (sur.homeContextPath?sur.homeContextPath.trim():"");
                tmpCampaign.notificationConfig.fromEmail = from;
                if(!campaign.isNonDeere && !campaign.isOpenEndedCampaign){ //In Case of Non-Deere or Open Ended Campaigns TO/CC/Backup is not required.
                    tmpCampaign.notificationConfig.toCode = to;
                    tmpCampaign.notificationConfig.ccCode = cc;
                    tmpCampaign.notificationConfig.backupContact = backupContact;
                }
            }
        });
        tmpCampaign.integrationQuestions = selectedQues;
        setValidated(true);
        if (form.checkValidity() && (campaign.assignments.length > 0 || campaign.isOpenEndedCampaign)) {
            const tempCC = cc.filter(el => {return el !== null && el !== undefined && el !== '' && el !== false })
            if(!validateNotificationTemplate()){
                setLoading(false);
                setValidated(true);
                setErrorMessage(ERR_EMAIL_TEMPLATE);
            }
            else if (new Date(campaign.startDate).getTime() > new Date(campaign.endDate).getTime()) {
                setLoading(false);
                setValidated(true);
                setErrorMessage(ERR_END_DATE);
            } 
            else if (isConflictMineral && (inputFile === '' || inputFile === null || inputFile === undefined)) {
                setLoading(false);
                setValidated(true);
                setErrorMessage(ERR_CMRT_FILE);
            }            
            else if(viewerQuestions.length > 0 && viewerQuestions.length !== attachmentFiles.length){
                setLoading(false);
                setValidated(true);
                setErrorMessage(ERR_ATTACHMENT);
            }
            else if(!from){
                setLoading(false);
                setValidated(true);
                setErrorMessage(ERR_FROM_FIELD);
            }
            else if(!campaign.isOpenEndedCampaign && !campaign.isNonDeere && !to){
                setLoading(false);
                setValidated(true);
                setErrorMessage(ERR_TO_FIELD);
            }
             else {
                setValidated(false);
                tmpCampaign.createdBy = userInfo.userID;
                setNotificationTemplateCodes(tmpCampaign);
                setDisableSubmit(true);
                if(tmpCampaign.code === CRS_SURVEY_CODES.CM){//here we will to create the survey first in order to get the survey id
                    postCMSurvey(authState.accessToken.accessToken, inputFile,userInfo.userID).then((response) => response.json()).then(data => {
                        if(data && data.surveyId){
                            tmpCampaign.surveyId = data.surveyId;
                                postCampaign(authState.accessToken.accessToken, tmpCampaign).then( async (resp) => {//Saving campaign
                                    let response = await resp.json();
                                    if(resp && resp.errorMessage){
                                        setSuccessMessage('The campaign will be created in a few minutes');
                                    }else{
                                        setSuccessMessage(`The campaign ${response.id} was created successfully`);
                                    }
                                    setLoading(false);
                                }).catch(error => {
                                    setLoading(false);
                                    setValidated(true);
                                    setErrorMessage(error);
                                    setDisableSubmit(false);
                                });
                            
                        }else{
                            setLoading(false);
                            setValidated(true);
                            setErrorMessage('Error Creating Campaign!');
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        setLoading(false);
                        setValidated(true);
                        setErrorMessage(error);
                        setDisableSubmit(false);
                    });
                }else if(tmpCampaign.code === CRS_SURVEY_CODES.EM){
                    postEMSurvey(authState.accessToken.accessToken, inputFile,userInfo.userID).then((response) => response.json()).then(data => {
                        if(data && data.surveyId){
                            tmpCampaign.surveyId = data.surveyId;
                                postCampaign(authState.accessToken.accessToken, tmpCampaign).then( async (resp) => {//Saving campaign
                                    let response = await resp.json();
                                    if(resp && resp.errorMessage){
                                        setSuccessMessage('The campaign will be created in a few minutes');
                                    }else{
                                        setSuccessMessage(`The campaign ${response.id} was created successfully`);
                                    }
                                    setLoading(false);
                                }).catch(error => {
                                    setLoading(false);
                                    setValidated(true);
                                    setErrorMessage(error);
                                    setDisableSubmit(false);
                                });
                            
                        }else{
                            setLoading(false);
                            setValidated(true);
                            setErrorMessage('Error Creating Campaign!');
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        setLoading(false);
                        setValidated(true);
                        setErrorMessage(error);
                        setDisableSubmit(false);
                    });
                }else{
                    //Generic survey
                    postCampaign(authState.accessToken.accessToken, tmpCampaign, attachmentFiles).then(async (resp) => {
                        let response = await resp.json();
                        if(resp && resp.errorMessage){
                            setSuccessMessage('The campaign will be created in a few minutes and you will be notified by email');
                        }else{
                            setSuccessMessage(`The campaign ${response.id} was created successfully`);
                        }
                        setLoading(false);
                    }).catch(error => {
                        setLoading(false);
                        setValidated(true);
                        setErrorMessage(error);
                        setDisableSubmit(false);
                    });
                }
            }
        } else {
                setErrorMessage('All fields are required');
                setLoading(false);
        }
        event.preventDefault();
        event.stopPropagation();
    }

    const validateNotificationTemplate = () => {
        let validity = true;
        if (notificationTemplate.length === 0) {
          validity = false;
        } else {
          let arrCode = notificationTemplate.map((nt) => nt.code.toUpperCase());
          let checkInitial = false;
          let checkReminder = false;
          arrCode.forEach((code) => {
            if (code.includes(NOTIFIC_TEMPLATE_CODE_INITIAL)) checkInitial = true;
            if (code.includes(NOTIFIC_TEMPLATE_CODE_REMINDER)) checkReminder = true;
          });
          if (!checkInitial || !checkReminder) {
            validity = false;
          }
        }
        return validity;
    };

    const setNotificationTemplateCodes = (tmpCampaign) => {
        let arrCode = notificationTemplate.map((nt) => nt.code);
        arrCode.forEach((code) => {
            if (code.toUpperCase().includes(NOTIFIC_TEMPLATE_CODE_INITIAL)) tmpCampaign.notificationConfig.initNotificationTemplateCode = code;
            if (code.toUpperCase().includes(NOTIFIC_TEMPLATE_CODE_REMINDER)) tmpCampaign.notificationConfig.remNotificationTemplateCode = code;
        });
    }

    const validateSupplierNumbers = event => {
        setLoading(true);
        setSuccessMessage('');
        setErrorMessage('');
        if (campaign.supplierNumbers) {
            if (campaign.supplierNumbers.indexOf(',') >= 0) {
                setValidated(true);
                setDisableSubmit(true);
                setErrorMessage(`Please remove the commas and special characters`)
                setLoading(false);
                return
            }

            const suppliersTmp = campaign.supplierNumbers.replace(/\r?\n/g, ',')
            const suppliersTmpVal = suppliersTmp.indexOf(',') < 0 ? [suppliersTmp] : suppliersTmp.split(',')
            const uniqueSuppliers = Array.from(new Set(suppliersTmpVal));
            const formattedSuppliers = uniqueSuppliers.map(s => { return s.trim().padStart(10, '0') })
            validateSupplierNumbersByChunk(authState.accessToken.accessToken, formattedSuppliers).then(sup => {
                if (sup && sup.length > 0) {
                    setValidated(true);
                    setDisableSubmit(true);
                    let errMsg = sup[0].length > 0 ? sup[0].join(', ') : sup[0]
                    if (errMsg === ', ' || errMsg.length === 0) {
                        setErrorMessage(`Please remove the empty lines`)
                    } else {
                        setErrorMessage(`The following supplier number(s) are invalid: ${errMsg}`)
                    }
                } else {
                    setValidated(false);
                    setDisableSubmit(false);
                    setSuccessMessage('All supplier numbers are valid');
                    let assignments = [];
                    let tmpCampaign = { ...campaign }
                    formattedSuppliers.forEach(element => {
                        assignments.push({
                            supplierNumber: element.trim(),
                            active: true,
                            createdBy: userInfo.userID,
                            status: CRS_REQUEST_STATUS_OBJ.EMAIL_PENDING
                        });
                    });
                    tmpCampaign.assignments = [...assignments];
                    setCampaign({ ...tmpCampaign });
                }
                setLoading(false);
            });
        } else {
            setValidated(true);
            setDisableSubmit(true);
            setErrorMessage(`At least one supplier is required.`);
            setLoading(false);
        }
    }

    return <div>
        <h1>{'Create Campaign'}</h1>
        {
            validated ? <CustomAlert accessibilityLabel={'Danger :'} variant={'danger'} title={errorMessage} /> : null
        }
        {
            successMessage ? <CustomAlert accessibilityLabel='success' variant='success' title={successMessage} /> : null
        }
        {
            loading ? <div className="d-flex w-100 justify-content-center align-items-center">
                <Spinner accessibilityLabel="Loading" className="uxf-spinner-border-lg" animation="border" />
            </div> : <></>
        }
        <Form noValidate onSubmit={handleSubmit} validated={validated}>
            <Card>
                <Card.Body>
                    <Form.Row>
                        <Form.Group as={Col}>
                            <Form.Label className="uxf-label">Survey Type</Form.Label>
                            <Form.Control required as="select" className="custom-select"
                                name='surveyId'
                                disabled={loading}
                                onChange={onChange}>
                                <option value=''>Select</option>
                                {surveys ? surveys.sort((a, b) => (a.description.toUpperCase() > b.description.toUpperCase()) ? 1 : -1).map(opt => <option key={opt.code} value={opt.id}>{opt.description}</option>) : null}
                            </Form.Control>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col}>
                            <Form.Label className="uxf-label">Start Date</Form.Label>
                            <Form.Control min={minimumDate} type="date" name='startDate' required onChange={onChange} disabled={loading} />
                        </Form.Group>
                        <Form.Group as={Col}>
                            <Form.Label className="uxf-label">End Date</Form.Label>
                            <Form.Control min={minimumDate} type="date" name='endDate' required onChange={onChange} disabled={loading || campaign.isOpenEndedCampaign} value={campaign.endDate}/>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col}>
                            <Form.Label className="uxf-label" style={{ marginRight: "10px" }}>{LBL_ISOPENCAMPAIGN_RADIO}</Form.Label>
                            <Form.Check type="radio" value='true' inline label='Yes' name="isOpenEndedCampaign" disabled={loading || CURRENT_ENV === ENV_PROD} onChange={onChange} checked={campaign.isOpenEndedCampaign} />
                            <Form.Check type="radio" value='false' inline label='No' name="isOpenEndedCampaign" disabled={loading || CURRENT_ENV === ENV_PROD} onChange={onChange} checked={!campaign.isOpenEndedCampaign} />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col}>
                            <Form.Label className="uxf-label" style={{ marginRight: "10px" }}>Is this for non-Deere units?</Form.Label>
                            <Form.Check type="radio" value='true' inline label='Yes' name="isNonDeere" disabled={loading || !nonDeereAvailable} onChange={onChange} checked={campaign.isNonDeere} />
                            <Form.Check type="radio" value='false' inline label='No' name="isNonDeere" disabled={loading || !nonDeereAvailable} onChange={onChange} checked={!campaign.isNonDeere} />
                        </Form.Group>
                        <Form.Group as={Col}>
                            <Stack direction="row" spacing={1}>
                                <Form.Label className="uxf-label" style={{ marginRight: "10px", whiteSpace: "nowrap" }}>Company Name</Form.Label>
                                <Form.Control name='companyName' disabled={loading || !nonDeereAvailable || !campaign.isNonDeere} onChange={onChange} value={campaign.companyName} required={campaign.isNonDeere}/>
                            </Stack>
                        </Form.Group>
                    </Form.Row>
                    {!campaign.isOpenEndedCampaign &&
                        (factoryLoader ? (
                            <Grid textAlign="center" mt={2} mb={2}>
                                <Spinner accessibilityLabel="Loading" className="uxf-spinner-border-md" animation="border" />
                                <Typography variant="h6">{FETCH_SURVEY_DATA}</Typography>
                            </Grid>
                        ) : (
                            <SurveyFactory
                            code={surveySelectedCd}
                            loading={loading}
                            setLoading={setLoading}
                            isEnable={isEnable}
                            setErrorMessage={setErrorMessage}
                            setSuccessMessage={setSuccessMessage}
                            campaign={campaign}
                            setValidated={setValidated}
                            setDisableSubmit={setDisableSubmit}
                            userInfo={userInfo}
                            setCampaign={setCampaign}
                            authState={authState}
                            setInputFile={setInputFile}
                            onChange={onChange}
                            validateSupplierNumbers={validateSupplierNumbers}
                            partSections={partSections}
                            partTemplateColumns={partTemplateColumns}
                            />
                        ))
                    }
                </Card.Body>
            </Card>
            <br/>
            {viewerQuestions && viewerQuestions.length > 0 && <AttachmentUploads viewerQuestions={viewerQuestions} setAttachmentFiles={setAttachmentFiles}/>}
            <br />
            <RemainderSettings campaign={campaign} setCampaign={setCampaign} initNotificationSubj={initNotificationSubj} remNotificationSubj={remNotificationSubj} loading ={loading} setFrom={setFrom} setTo={setTo} setCc={setCc} setBackupContact={setBackupContact} lblCompanyName={lblCompanyName}/>
            <br />
            {COC_SHOW_INTEGRATION_SECTION === 'true' && (campaign.code === CRS_SURVEY_CODES.COC || campaign.code === CRS_SURVEY_CODES.LHR || campaign.code === CRS_SURVEY_CODES.CTPAT || campaign.templateType === CRS_SURVEY_TEMPLATES.PART) ? (
                <IntegrationSettings campaign={campaign} authState={authState} selectedQues={selectedQues} setSelectedQues={setSelectedQues} selectedSec={selectedSec} setSelectedSec={setSelectedSec} loading={loading}/>
            ) : null}            
            <Form.Group as={Col} className="align-right">
                <br />
                <Form.Row>
                    <Col>
                        <Button variant="primary" className="float-right" type='submit' disabled={disableSubmit}>
                            Submit
                        </Button>
                        <Button variant="secondary" className="float-right mr-2" onClick={e => history.goBack()} disabled={loading}>
                            Back to Search
                        </Button>
                    </Col>
                </Form.Row>
            </Form.Group>
        </Form>
    </div>
}